






































































import {
    Component,
    Vue
} from "vue-property-decorator";
import {
    common
} from "@/Pages/Admin/Modules/Common/Services/Common";
import {
    Cookie
} from "@/Pages/Admin/Modules/Common/Services/CookieService";
import GeneralStore from "@/Pages/Admin/Modules/ManagePackage/Store/General";

@Component({
    name: "TheNavBar",
    components: {}
})
export default class TheNavBar extends Vue {
    private is_toggle: boolean;
    private activeUser: {};
    protected ui: any = {};
    protected errors: any = {};

    constructor() {
        super();
        this.is_toggle = false;
        this.activeUser = {};
    }
    public redirectToProfile() {
    console.log("Profile Personal");
        this.$router.push({
            name: 'business-dashboard-manage-individualProfile',
            // query: {
            //   id: this.$route.query.id,
            // },
        });
    }
    public redirectToPassword() {
        this.$router.push({
            name: 'user-profile-change-password',
            // query: {
            //   id: this.$route.query.id,
            // },
        });
    }

    LogoutAction(event: any) {
        event.preventDefault();
        if (Cookie.check("business_auth_token")) {
          localStorage.clear()
            Cookie.delete("business_auth_token");
            this.$router.push({
                name: "business-login"
            });
        }
    }
    toggleMenu() {
        $("#wrapper").dropdown('toggle');
    }
    dropdown(e: any) {
        // e.stopPropagation();
        $('.dropdown-toggle').dropdown('toggle');

    }
    mounted() {
        this.activeUser = common.CurrentLoggedBusinessUser() ?
            common.CurrentLoggedBusinessUser() :
            "";
        // this.GetUserInfromationList();
        // console.log("login check", this.activeUser);
    }
    
    

}
